import React from "react";

import { ContentHolder } from "commons";

import { AdHocFees } from "./AdHocFees";

export function AuthorisationsContainer() {
    return (
        <ContentHolder>
            <AdHocFees />
        </ContentHolder>
    );
}
